import { BannersPreviewDataDict } from '../typings/state';

export const LOAD_BANNERS_PREVIEW = 'LOAD_BANNERS_PREVIEW';
export type LOAD_BANNERS_PREVIEW = typeof LOAD_BANNERS_PREVIEW;
export interface LoadBannersPreviewAction {
    type: LOAD_BANNERS_PREVIEW;
    campaignId: string;
    groupId: string;
}
export function loadBannersPreview(campaignId: string, groupId: string): LoadBannersPreviewAction {
    return {
        type: LOAD_BANNERS_PREVIEW,
        campaignId,
        groupId
    };
}

export const UPDATE_BANNERS_PREVIEW = 'UPDATE_BANNERS_PREVIEW';
export type UPDATE_BANNERS_PREVIEW = typeof UPDATE_BANNERS_PREVIEW;
export interface UpdateBannersPreviewAction {
    type: UPDATE_BANNERS_PREVIEW;
    bannersPreviewData: BannersPreviewDataDict;
}
export function updateBannersPreview(bannersPreviewData: BannersPreviewDataDict): UpdateBannersPreviewAction {
    return {
        type: UPDATE_BANNERS_PREVIEW,
        bannersPreviewData
    };
}

export type BannersPreviewAction = LoadBannersPreviewAction | UpdateBannersPreviewAction;
